import React from 'react';
import SliderConsultwith from '../swiper/sliderConsultwith'

export default function ({ highlightsfeed, eleRef }) {
    return (
        <section className="main_container_block_feeds baby_view_more">
        <div className="main_block_container_feed ">
              <div className="docConnect_heading_video R15_61">
                 {highlightsfeed.title}
              </div> 
              <div className="docConnect_Bg-section_main">
                  <div className="content-div_view_artical">
                     <img src={highlightsfeed.bannerImage} alt="logo"/>
                  </div>
                  <div className="docConnect_consult_with">
                       <div className="doc_consult_heading B18_white">{highlightsfeed.subTitle}</div>
                       <SliderConsultwith page={"dr-carousel-unit"} data={highlightsfeed.data} />
                  </div>
                  <div className="doc_connect_cosult">
                      <button className="M15_42" type="button"> View all </button>
                  </div>
              </div>
          </div>
      </section>

    )
}
